import React from "react";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-language">Indonesia</div>
            <div className="footer-tnc">
                <div className="left-tnc">
                    <span>About</span>
                    <span>Advertising</span>
                    <span>Business</span>
                    <span>How Search works</span>
                </div>
                <div className="right-tnc">
                    <span>Privacy</span>
                    <span>Terms</span>
                    <span>Settings</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
